const CONTEXT_LATEST_DESIGN_VERSION = 6;

/**
 * This is the consent which got given after clicking on a button. Currently, it holds
 * only a list of accepted groups and services inside the groups.
 */

export { CONTEXT_LATEST_DESIGN_VERSION };